import React, { useState } from 'react';
import { Paper, Grid, Button, Typography, TextField } from '@mui/material';

import { useAppDispatch } from '../../../redux/stores/hooks';
import { createTemplate } from '../../../redux/actions/templates';
import { ROUTES } from '../../../components/consts';
import { Code } from '../../../components/types/templates/types';
import { initialStateCode } from './editors/components/initialStateCode';
import { Editors } from './editors';
import { GalletyPreview } from './galleryPreview.component';
import AddIcon from '@mui/icons-material/Add';
import { Navigate } from 'react-router';

export const CreateTemplate: React.FC = () => {
  const dispatch = useAppDispatch();
  const [name, setName] = useState('');
  const [code, setCode] = useState<Code>(initialStateCode);

  return (
    <Grid sx={{
      width: '100%',
      padding: '10px',
      '& hr': {
        margin: '10px auto',
      },
    }} container spacing={1}>
      <Grid item xs={12}>
        <Paper sx={{
    padding: '10px',
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  }}>
          <Typography
            component="h1"
            variant="h6"
            color="inherit"
            noWrap
            sx={{
              flexGrow: 1,
              marginBottom: '10px',
            }}
          >
            Dodaj szablon
          </Typography>
          <TextField
            placeholder="Nazwa szablonu"
            value={name}
            onChange={(e) => setName(e.target.value)}
            sx={{ mt: 2, mb: 2 }}
          ></TextField>
          <Editors setCode={setCode} />
          <Button
            fullWidth
            color="primary"
            variant="contained"
            onClick={() => {
              dispatch(
                createTemplate({
                  name: name,
                  code: code,
                }),
              );
              return <Navigate to={ROUTES.templates.href} />;
            }}
            startIcon={<AddIcon />}
          >
            Dodaj
          </Button>
        </Paper>
        <GalletyPreview code={code} />
      </Grid>
    </Grid>
  );
};
